export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11286.97cfb1ef.jpg";